import React from "react";
import { Form, Input, Button } from "antd";

const ForgotPasswordForm = ({ onSubmit }) => {
	return (
		<Form
			scrollToFirstError
			layout="vertical"
			hideRequiredMark
			colon={false}
			onFinish={onSubmit}
		>
			<div className="form-content">
				<div className="forgot-password-title">
					Enter the email address you used to create for your account.
				</div>
				<Form.Item
					label="Email Address"
					name="email"
					rules={[
						{ type: "email", message: "Invalid Email" },
						{ required: true, message: "Required" },
					]}
				>
					<Input size="large" placeholder="Email Address" />
				</Form.Item>
			</div>
			<div className="form-footer">
				<Button
					type="primary"
					htmlType="submit"
					block
					size="large"
					className="btn btn-primary"
				>
					Continue
				</Button>
			</div>
		</Form>
	);
};

export default ForgotPasswordForm;
